import { Link, Outlet } from "@tanstack/react-router";
import { Ban, CreditCard, FileUp, Globe, Image, Megaphone, Users, Workflow } from "lucide-react";
import { PageBreadcrumbs } from "@/components/shared/page-breadcrumbs";
import { cn } from "@/lib/utils";

const configPages = [
  { to: "/config/announcements" as const, title: "Announcements", icon: Megaphone },
  { to: "/config/branding" as const, title: "Branding", icon: Image },
  { to: "/config/cancel-reasons" as const, title: "Cancel Reasons", icon: Ban },
  { to: "/config/pay-plan" as const, title: "Pay Plan", icon: CreditCard },
  { to: "/config/region" as const, title: "Regions", icon: Globe },
  { to: "/config/upload-pdf" as const, title: "Upload PDFs", icon: FileUp },
  { to: "/config/users" as const, title: "Users", icon: Users },
  { to: "/config/workflows" as const, title: "Workflows", icon: Workflow },
];

export function ConfigLayoutPage() {
  return (
    <div className="space-y-4">
      <PageBreadcrumbs current="Configuration" />
      <div className="grid gap-4 md:grid-cols-12">
        {/* ─── LEFT: Navigation ─── */}
        <nav className="space-y-2 md:col-span-3">
          {configPages.map((page) => (
            <Link
              key={page.to}
              to={page.to}
              className={cn(
                "flex items-center gap-2 rounded-md border px-3 py-2 text-sm font-medium transition-colors",
                "bg-card text-foreground hover:bg-accent",
              )}
              activeProps={{
                className: "!bg-primary !text-primary-foreground !border-primary",
              }}
            >
              <page.icon className="size-4" />
              {page.title}
            </Link>
          ))}
        </nav>

        {/* ─── RIGHT: Active config section ─── */}
        <div className="md:col-span-9">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export function ConfigIndexPage() {
  return (
    <div className="rounded-md border bg-card p-8 text-center">
      <h2 className="font-semibold text-xl">Configuration</h2>
      <p className="mt-2 text-muted-foreground">
        Select a section from the left to manage reference data and settings.
      </p>
    </div>
  );
}
